var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "padlock",
    d: "M18.75,9H18V6A6,6,0,0,0,6,6V9H5.25A2.253,2.253,0,0,0,3,11.25v10.5A2.253,2.253,0,0,0,5.25,24h13.5A2.253,2.253,0,0,0,21,21.75V11.25A2.253,2.253,0,0,0,18.75,9ZM8,6a4,4,0,0,1,8,0V9H8Zm5,10.722V19a1,1,0,0,1-2,0V16.722a2,2,0,1,1,2,0Z",
    transform: "translate(-3)",
    fill: "#0056a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.5904cee81f0509aa2f05ae9f24cf494e.svg";
export { ForwardRef as ReactComponent };